import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { useTempIdMap } from '~/client/hooks/storeHooks';
import { isTempNumericId } from '~/common/tinybase/utils';

const missingItemTimeoutMs = 1000;

/**
 * If the currently selected item is pending, this hook will automatically update the url path
 * with the real ID once the item has been saved to the source system and synced
 * */
export const useHandlePendingItem = (
  itemId: ScalarId | undefined,
  toItemListPage: string,
  toSavedItemPage: (realId: string) => string,
) => {
  const navigate = useNavigate();

  const [tempId, setTempId] = useState<ScalarId>();

  const { realId } = useTempIdMap(tempId) || {};

  useEffect(() => {
    if (itemId && isTempNumericId(itemId)) {
      setTempId(itemId);
    }
  }, [itemId]);

  useEffect(() => {
    if (tempId && realId) {
      void navigate(toSavedItemPage(realId), { replace: true });
      setTempId(undefined);
    } else if (tempId && !itemId) {
      const timeout = setTimeout(() => navigate(toItemListPage), missingItemTimeoutMs);
      return () => clearTimeout(timeout);
    }
  }, [itemId, tempId, realId]);

  return { isPendingItem: !!tempId };
};
